import { collectionsServerResponseType, sortedCollectionsType } from '../types';
import { convertLabelToId } from './convertLabelToId';

export const organizeCollections = (
  rawData: collectionsServerResponseType,
): sortedCollectionsType[] => {
  const categories = rawData.facets.find(
    (facet) => facet.field === 'categories',
  );
  const collections = rawData.results;
  const organizedCollections: sortedCollectionsType[] = [];
  if (categories) {
    categories.values.forEach((category) => {
      organizedCollections.push({
        category_id: convertLabelToId(category.label),
        label: category.label,
        results: collections.filter((collection) =>
          collection.categories.includes(category.label),
        ),
      });
    });
  }

  return organizedCollections;
};
